"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _atoms = require("../../atoms");
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = exports.Wrapper = (0, _styledComponents["default"])(_atoms.View)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\nbackground-color: #plum;\nborder-top-left-radius: 20px;\nborder-top-right-radius: 20px;\nborder-bottom: rounded(0.5);\nfont-family: var(--font-family);\nfont-size: 0.7em;\noverflow: auto;\npadding-left: 20px;\npadding-right: 20px;\nposition: fixed;\nbottom: 0;\nleft: 0;\nwidth: 50%;\nz-index: 1000;\n"])));